import styled from 'styled-components';

import { RadioRound, SelectedRadioRound } from 'components/RadioButtons';

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;

  span {
    margin-left: 10px;
  }
`;

export const Radio = styled(RadioRound)`
  display: inline-block;
`;

export const SelectedRadio = styled(SelectedRadioRound)`
  display: inline-block;
`;

export const ModalBodyContainer = styled.div`
  padding-bottom: 10px;
`;
